function showSubLinkFilters(prodSubLink, productCategory) {
  return Object.values(prodSubLink ?? {}).some(item =>
    (item['require-on-category'] || []).includes(productCategory)
  );
}

export default showSubLinkFilters;
